"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BatchCreatePaymentsResponse = exports.BatchCreatePaymentsRequest = exports.BatchPaymentItem = void 0;
const typebox_1 = require("@sinclair/typebox");
const invoice_transport_1 = require("./invoice-transport");
const payment_transport_1 = require("./payment-transport");
exports.BatchPaymentItem = typebox_1.Type.Object({
    payableID: typebox_1.Type.String({ format: 'uuid' }),
    payment: payment_transport_1.PaymentCreateTransport,
});
exports.BatchCreatePaymentsRequest = typebox_1.Type.Object({
    payments: typebox_1.Type.Array(exports.BatchPaymentItem, { minItems: 1 }),
});
exports.BatchCreatePaymentsResponse = typebox_1.Type.Object({
    results: typebox_1.Type.Array(typebox_1.Type.Object({
        payment: payment_transport_1.PaymentTransport,
        invoice: invoice_transport_1.InvoiceTransport,
    })),
});
//# sourceMappingURL=batch-payments.js.map